import type { Components, Theme } from '@mui/material/styles'

export const MuiSelectOverride: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    // Route every select's dropdown through the `selectMenu` Paper variant so
    // dropdowns pick up the shared surface treatment without per-call-site props.
    MenuProps: {
      slotProps: {
        paper: {
          variant: 'selectMenu',
        },
      },
    },
  },
}
